<div class="container">
    <div class="pt-3 pb-2">
        <div class="row g-0 align-items-center">
            <div class="col-12">
                <div class="draft-banner mt-3">
                    <div class="draft-banner__heading">
                        <span>Mudahnya menemukan peluang yang siap Anda menangkan.</span>
                    </div>
                    <div class="draft-banner__features">
                        <div class="draft-banner__feature-item">
                            <i class="bi bi-check-circle-fill"></i> AI RFQ Matching
                        </div>
                        <div class="draft-banner__feature-item">
                            <i class="bi bi-check-circle-fill"></i> Indikator Pasar
                        </div>
                        <div class="draft-banner__feature-item">
                            <i class="bi bi-check-circle-fill"></i> Autobid System
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-12">
                <app-breadcrumb 
                    returnAction="/" 
                    [breadcrumbs]="[
                        { label: '/ &nbsp;&nbsp; Pasar RFQ' } 
                    ]"
                >
                </app-breadcrumb>
            </div>
        </div>
    </div>

            <div class="">
                <div class="row">
                    <div class="col-12 mb-3">
                        <div class="cd-title">
                            
                            <div class="row">
                            <div class="col-12">
                                Pasar RFQ
                            </div>
                            </div>



                        </div>
                    </div>

                    <div class="col-12 mb-3">
                        <div class="container cd-content py-md-3 px-md-4">

                            <div class="cd-content">

                                <div class="row">

                                    <div class="col-12">
                                        <div class="row align-items-center divTemplate">
                                            <!-- <div class="col-5">
                                                <h5 class="cd1">RFQ Terbaru</h5>
                                            </div>
                                            <div class="col-7 text-end">
                                                <a class="pointer btn-ceda-third" href="/regis">Tambahkan RFQ anda</a>
                                            </div> -->
                                            <!-- <div class="col-12">
                                                <hr>
                                            </div> -->
                                            <div class="col-12" *ngIf="publicRFQLoading">

                                                <div class="text-center pt-5 pb-5">
                                                    <div class="loader loader--style8" title="7">
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                                                        <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
                                                        <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" />
                                                        <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                                                        <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                                                        </rect>
                                                        <rect x="8" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                                                        <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                                                        <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                                                        <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                                                        </rect>
                                                        <rect x="16" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                                                        <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                                                        <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                                                        <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                                                        </rect>
                                                    </svg>
                                                    </div>
                                                </div>  

                                            </div>

                                            <div class="col-12" *ngIf="!publicRFQLoading">
                                                <div class="py-2 scrollspy-rfq">
                                                    <ng-container *ngFor="let rfqboard of dataRfqBoard; let i = index">
                                                        <div class="mb-4">
                                                            <app-board-rfq class="cd-card mb-3" [rfq]="rfqboard" [forceMobile]="true"></app-board-rfq>
                                                        </div>
                                                    </ng-container>


                                                    <!-- <ng-container *ngFor="let rfqboard of dataRfqBoard; let i = index">
                                                        <app-board [rfq]="rfqboard" [forceMobile]="true"></app-board>
                                                    </ng-container> -->
                                                </div>


                                            </div>
                                            
                                        </div>
                                    </div>                                    



                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

</div>